import React, {useState, useRef, useEffect} from 'react';
import FilePicker from './FilePicker.mjs';
import FileTable from './FileTable.mjs';
import { useCTAL } from './CTAL_Hooks.js';

const DEBUG = false;

export default function ActionItemFiles() 
{
    const { action_item, action_item_files, action_item_display_refresh, setSelectedActionItem, setActionItemDisplayRefresh } = useCTAL();

    useEffect(() =>
    {
        if (DEBUG) console.log(`ActionItemFiles** - RESET, action-item: ${action_item.Name}, Priority: ${action_item.Priority}`);
    }, [action_item,  action_item_display_refresh]);

    const refresh_action_item = () => { 
        setSelectedActionItem(action_item); //Keep this Action Item Detail Displayed
        setActionItemDisplayRefresh(true);  //Trigger the Action-Item bulk download in ActionItem.mjs
    }

    const picker_prefix = "ActionFiles";

    return (
        <>
            <h6 class="mt-2">File Attachments</h6>
            
            <FilePicker home_team_id={action_item.HomeTeamID} target_type={action_item.Type} target_id={action_item.ActionItemID} refresh_target = {refresh_action_item} picker_prefix={picker_prefix} /> 
            
            <FileTable files={action_item_files} margin_top={"mt-2"} />     
        </>
    );
}